import * as player from '../player.js';
import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import { Tween } from '../tweens.js'

export {
    init,
}

let veloSound;

const POIs = [
    {
        name: 'velo',
        position: { x: -18, y: 20, z: 0 },
        color: 'orange',
        radius: 5,
        sound: {
            name: 'velo-idle',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
        collision: {
            radius: 1,
        },
        async onEnter() {
            // Follow player
            this.sound.source.fadeTo(1, -90, -12);
            veloSound = await audio.buffers.play('velo', {
                loop: true,
                gain: 0,
            });
            const originalPosition = { ...this.position };
            new Tween(this.position, player.position, 1, 'easeOutQuad', (v) => {
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween) => {
                setTimeout(() => {
                    this.sound.source.fadeTo(1, -12, -90);
                    // Manual cleanup to stop following player
                    tween.dispose();
                    veloSound.fade();
                    new Tween(this.position, originalPosition, 4, 'easeInOutQuad', (v) => {
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new Tween(12, 5, 2, 'easeOutQuad', (v) => {
                        this.radius = v;
                    });
                }, 10000);
            });
            // Increase radius to 15
            new Tween(this.radius, 12, 0.5, 'easeOutQuad', (v) => {
                this.radius = v;
            });
        },
    },
];

const sounds = [
    { name: 'velo-idle', url: new URL('../../sound/SonetteCourte.wav', import.meta.url) },
    { name: 'velo', url: new URL('../../sound/ChaineVelo.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
